
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    getCalculationOperations,
    getMapContent,
    getPricelistData,
    getUsekMezItems,
    getUsekMezAttributes
} from '../../reducers/project';

import projectGetActions from '../../sagas/project';

import download from '../common/download';

import { PAGE_USEK_INPUT, PAGE_PRICELIST, redirectToPage } from '../pagesDefinition';

import calculateSummary from './calculateSummary';
import generateCalculationPdf from './generateCalculationPdf';
import getModificationById from './getModificationById';
import getOperationsForModification from './getOperationsForModification';
import CalculationPageView from './CalculationPage.view';
import Summary from './Summary.state';
import UsekList from './UsekList.state';

const CalculationPageState = () => {

    const dispatch = useDispatch();
    const projectActions = projectGetActions(dispatch);

    const calculationOperations = useSelector(state => getCalculationOperations(state.project));
    const mapContent = useSelector(state => getMapContent(state.project));
    const pricelistData = useSelector(state => getPricelistData(state.project));
    const usekMezItems = useSelector(state => getUsekMezItems(state.project));
    const usekMezAttributes = useSelector(state => getUsekMezAttributes(state.project));

    React.useEffect(() => {
        if (!usekMezItems || (usekMezItems.length === 0)) {
            redirectToPage(PAGE_USEK_INPUT);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getFirstOperationItem = (operation) => {
        return pricelistData.items.reduce((previous, current) => {
            return ((current.opId === operation.id) && !previous)
                ? current
                : previous;
        }, null);
    }

    const getToolbarItems = () => {
        let items = [];
        items.push({onClick: handleAutoFillClick, title: 'Automaticky vyplnit'});
        if (mapContent) {
            items.push({onClick: handleExportPdfClick, title: 'Export do PDF'});
            items.push({onClick: handleExportGeoJsonClick, title: 'Export do GeoJSON'});
        }
        return items;
    }

    const handleAutoFillClick = () => {
        usekMezItems.forEach(usek => {
            let attributes = usekMezAttributes[usek.properties.id_usek];

            const mob = getModificationById(attributes.typ_uprav_stavba);
            const mov = getModificationById(attributes.typ_uprav_vegetace);
            const operations = [
                ...getOperationsForModification(mob),
                ...getOperationsForModification(mov)
            ];
            operations.forEach(operation => {
                let calcOp = calculationOperations[`${usek.properties.id_usek}_${operation.id}`];
                if (!calcOp) {
                    const operationItem = getFirstOperationItem(operation);
                    if (operationItem) {
                        projectActions.setCalculationOperation(
                            usek.properties.id_usek,
                            operation.id, operationItem.id,
                            operationItem.price
                        );
                    }
                }
            });
        });
    }

    const handleExportGeoJsonClick = () => {
        let data = {
            type: 'FeatureCollection',
            features:[]
        };

        usekMezItems.forEach(item => {
            let feature = {
                type: 'Feature',
                geometry: JSON.parse(item.geometry),
                properties: {...item.properties}
            };
            data.features.push(feature);
        });

        download('useky.json', null, JSON.stringify(data));
    }

    const handleExportPdfClick = () => {
        const calcSummary = calculateSummary(
            usekMezItems, calculationOperations, pricelistData, usekMezAttributes
        );
        generateCalculationPdf(
            mapContent,
            calcSummary,
            (pdf) => {
                pdf.save('export.pdf');
            }
        );
    }

    const handleGoBackClick = () => {
        redirectToPage(PAGE_PRICELIST);
    }

    const renderSummary = () => {
        return (usekMezItems && (usekMezItems.length > 0))
        ? (
            <Summary
            />
        )
        : null;
    }

    const renderUsekList = () => {
        return (usekMezItems && (usekMezItems.length > 0))
            ? (
                <UsekList
                />
            )
            : null;
    }

    return (
        <CalculationPageView
            onGoBackClick={handleGoBackClick}
            summary={renderSummary()}
            toolbarItems={getToolbarItems()}
            handleAutoFillClick={handleAutoFillClick}
            usekList={renderUsekList()}
        />
    )
}

export default CalculationPageState;